import { Pager, setupPagers } from './components';
import { debounce } from './utils';

interface EventData {
  source: string;
}

export function setupAutoSubmitForms() {
  const forms = $('form');
  $.each(forms, (_, element) => {
    const form = $(element);

    if (form.data('is-autosubmit')) {
      form.on('submit', handleFormSubmit);
    }

    const inputs = form.find('input[data-is-autosubmit="true"]');

    inputs.each((_, elem) => {
      const input = $(elem);
      const type = input.attr('type');

      if (type === 'hidden' || type === 'checkbox') {
        input.on('change', (_, eventData) =>
          form.trigger('submit', [eventData])
        );
        return;
      }

      if (type === 'text' || type === 'date') {
        setupTextInput(input, form);
      }
    });
  });
}

function handleFormSubmit(e: JQuery.SubmitEvent, eventData?: EventData) {
  e.preventDefault();
  const form = $(this);

  const method = form.attr('method');
  if (method === 'get') {
    submitGetForm(form, eventData);
    return;
  }

  const data = form.serialize();
  const url = form.attr('action');

  $.ajax({
    type: method,
    url: url,
    data,
  });
}

function submitGetForm(form: JQuery<HTMLFormElement>, eventData?: EventData) {
  const results = getResultsElement(form);
  const loadable = getLoadableElement(results);
  startLoadingIndicator(loadable);

  const url = form.attr('action');
  const dataArray = form.serializeArray();

  if (eventData?.source !== Pager.EVENT_SOURCE) {
    const pageNumberAttr = dataArray.find((x) => x.name === 'PageNumber');
    if (pageNumberAttr) {
      pageNumberAttr.value = '1';
    }
  }

  const pageUrl =
    window.location.origin +
    window.location.pathname +
    '?' +
    $.param(dataArray);
  window.history.pushState({}, '', pageUrl);

  dataArray.push({ name: 'ajax', value: 'true' });
  const data = $.param(dataArray);

  $.ajax({
    type: 'get',
    url: url,
    data,
    success: (data) => {
      results.html(data);

      setupPagers();
      stopLoadingIndicator(loadable);
    },
    error: (error) => {
      stopLoadingIndicator(loadable);
    },
  });
}

function setupTextInput(input: JQuery<HTMLElement>, form: JQuery<HTMLElement>) {
  let minLength = 0;

  const minLengthAttr = input.data('min-length');
  if (minLengthAttr) {
    minLength = Number(minLengthAttr);
  }

  const debounceTimeout = input.data('autosubmit-debounce') || 300;

  input.on(
    'input',
    debounce(
      (e: JQuery.ChangeEvent<HTMLInputElement>, eventData?: EventData) => {
        const target = e.target as HTMLInputElement;

        if (target.value && target.value.length >= minLength) {
          form.trigger('submit', [eventData]);
        }
      },
      debounceTimeout
    )
  );
}

function getResultsElement(form: JQuery<HTMLFormElement>) {
  return $('#' + form.data('results-id'));
}

function getLoadableElement(results: JQuery<HTMLElement>) {
  return results.closest('.loadable');
}

function startLoadingIndicator(loadable: JQuery<HTMLElement>) {
  if (loadable) {
    loadable.addClass('loadable--loading');
  }
}

function stopLoadingIndicator(loadable: JQuery<HTMLElement>) {
  if (loadable) {
    loadable.removeClass('loadable--loading');
  }
}
